// extracted by mini-css-extract-plugin
export var rateTable = "_41-0";